import { PATH_FIXED_LAYOUT_EDITOR } from 'app/router/routesConfigFixedLayout';
import { USER_ROLES } from 'app/services/users.service';

export function fixedLayout(path, user, settings) {
  if (PATH_FIXED_LAYOUT_EDITOR === path) {
    const { cms_have_fixed_layout_editor_role } = settings;
    const isRolFixedLayout = USER_ROLES.adminFixedLayout === user?.role_guid;
    const hasPermissions = cms_have_fixed_layout_editor_role ? isRolFixedLayout : true;

    return hasPermissions;
  }

  return true;
}
